__turbopack_context__.v({
  "container": "organization-sticky-footer-content-module-scss-module__kvotcG__container",
  "enroll-now-cta-button": "organization-sticky-footer-content-module-scss-module__kvotcG__enroll-now-cta-button",
});
